import { z } from 'zod';
import { AppointmentMessage } from './appointment-message';
import { AppointmentMessageVote } from './appointment-vote';

export const AppointmentStatus = z.enum(['scheduled', 'staged', 'picked-up', 'returned', 'canceled']);
export type AppointmentStatus = z.infer<typeof AppointmentStatus>;

export const TransitionAuditEvent = z.object({
  gps: z.object({ lat: z.number(), lng: z.number() }).nullable().optional(),
  geofencePass: z.boolean().nullable().optional(),
  accuracyMeters: z.number().nullable().optional(),
  capturedAt: z.string().datetime().optional(),
});
export type TransitionAuditEvent = z.infer<typeof TransitionAuditEvent>;

export const WsAppointmentEvent = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('message.created'),
    appointmentId: z.string().uuid(),
    message: AppointmentMessage,
  }),
  z.object({
    type: z.literal('vote.cast'),
    appointmentId: z.string().uuid(),
    vote: AppointmentMessageVote,
  }),
  z.object({
    type: z.literal('appointment.transitioned'),
    appointmentId: z.string().uuid(),
    status: AppointmentStatus,
    actorUserId: z.string().uuid(),
    actorRole: z.string(),
    audit: TransitionAuditEvent.nullable().optional(),
    occurredAt: z.string().datetime(),
  }),
  z.object({
    type: z.literal('lockbox.revealed'),
    appointmentId: z.string().uuid(),
    viewerUserId: z.string().uuid(),
    revealedAt: z.string().datetime(),
  }),
]);
export type WsAppointmentEvent = z.infer<typeof WsAppointmentEvent>;

export const WsJoinAck = z.object({
  appointmentId: z.string().uuid(),
  cursor: z.string().datetime().nullable(),
});
export type WsJoinAck = z.infer<typeof WsJoinAck>;
